import { StackPanel, Typography, FlexBox, Illustration } from '@agilepoint/wat-react-ux';
import { Illustartions } from '@agilepoint/web-components';
import { CSSProperties } from 'styled-components';
import { DefaultUploadImages } from '../defaults';
import { ContentWrapper } from '../styled-components';
import { AppLogoTile } from './app-logo-tile';

interface IAppLogoTilePreviewLayoutProps {
    appTileMetadata: {
        headingLabel: string;
        logoTileDetails: {
            imageType: string;
            imageSize: string;
            imagePickerFieldName: string;
            resetImageURL: DefaultUploadImages;
        }[];
        appIllustrationName: keyof Illustartions;
    }[];
    isAndroid?: boolean;
    menuColor?: string;
}

export const AppLogoTilePreviewLayout = (props: IAppLogoTilePreviewLayoutProps) => {
    const { appTileMetadata, menuColor } = props;
    const backgroundColor: CSSProperties = (menuColor) ? { backgroundColor: menuColor } : {};
    return (
        <StackPanel gap="20" orientation='vertical' width="100%">
            {
                appTileMetadata.map((app) => (
                    <ContentWrapper key={app.headingLabel} gap='22' orientation='vertical' width="100%" height="281px">
                        <Typography.H6 title={app.headingLabel}>{app.headingLabel}</Typography.H6>
                        <FlexBox justifyContent="space-between" width="100%" height="calc(100% - 39px)">
                            <StackPanel gap="20">
                                <>
                                    {
                                        app.logoTileDetails.map((logoDetails) => (
                                            <AppLogoTile
                                                backgroundColor={backgroundColor}
                                                key={logoDetails.imageType}
                                                imageType={logoDetails.imageType}
                                                imageSize={logoDetails.imageSize}
                                                imagePickerFieldName={logoDetails.imagePickerFieldName}
                                                resetImageURL={logoDetails.resetImageURL} />
                                        ))
                                    }
                                </>
                            </StackPanel>
                            <Illustration type={app.appIllustrationName} height="218px" />
                        </FlexBox>
                    </ContentWrapper>
                ))
            }
        </StackPanel>
    );
};
